exports._parseJSON = JSON.parse;

exports._undefined = undefined;

exports._unsafeStringify = JSON.stringify;
